import { Component, ViewChild, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { InputForm, InputInterface } from 'src/app/classes/input';
import { UserNeedService } from 'src/app/classes/services/user-need.service';
import { AppComponent } from 'src/app/app.component';
import { ToastrService } from 'ngx-toastr';
import { GiftInter } from '../../../../classes/interfaces/gift-Inter';

const formDataInit: GiftInter = {
  id: 0,
  firstName: '',
  lastName: '',
  phoneNumber: '',
  email: '',
  orderID: 0,
  isActive: true,
  userWant: 1,
  productId: 0,
  description: '',
  urlUserNeed: ''
};

@Component({
  selector: 'app-consultation-form',
  templateUrl: './consultation-form.component.html',
  styleUrls: ['./consultation-form.component.scss'],
})
export class ConsultationFormComponent {
  get isBrowser() {
    return AppComponent.isBrowser.value;
  }

  @Input('isGreen') GreenStyles: boolean = false;
  @Input('toggleType') type: number = 1;
  @ViewChild('scrollHere') elementScroll: HTMLElement;

  formControlInit: InputInterface[] = [
    {
      id: 1,
      label: 'نام',
      name: 'firstName',
      class: 'input-without-icon',
      typeofVlaue: 'string',
      placeholder: 'نام',
      required: false,
      hasErr: false
    },
    {
      id: 3,
      label: 'نام خانوادگی',
      name: 'lastName',
      typeofVlaue: 'string',
      class: 'input-with-icon',
      required: false,
      placeholder: 'نام خانوادگی',
      hasErr: false
    },
    {
      id: 2,
      label: 'شماره تماس',
      name: 'phoneNumber',
      type: 'pattern',
      class: 'input-without-icon',
      typeofVlaue: 'string',
      placeholder: 'شماره تماس',
      required: true,
      hasErr: false
    },
    {
      id: 4,
      label: 'email',
      name: 'Email',
      type: 'email',
      class: 'input-without-icon',
      typeofVlaue: 'string',
      placeholder: 'ایمیل',
      required: false,
      hasErr: false
    },
  ];

  formControls!: InputInterface[];
  form: FormGroup;
  formMaker = new InputForm(this.formControlInit);

  animation = false;
  
    activeAnimation() {
      this.animation = true;
    }

    deactivateAnimation() {
      this.animation = false;
    }

  // مرحله OTP
    otpStep = false;
    otpCode = '';
    otpSending = false;
    otpCooldown = 0;
    otpCooldownTimer: any;

    startOtpCooldown(seconds: number = 60) {
      this.otpCooldown = seconds;
    
      clearInterval(this.otpCooldownTimer);
    
      this.otpCooldownTimer = setInterval(() => {
        this.otpCooldown--;
    
        if (this.otpCooldown <= 0) {
          clearInterval(this.otpCooldownTimer);
          this.otpCooldownTimer = null;
        }
      }, 1000);
    }

  constructor(
    private giftFormService: UserNeedService,
    private toaster: ToastrService
  ) {
    this.form = new FormGroup({});

    this.formMaker.inputs.forEach((item) => {
      this.form.setControl(
        item.name,
        this.formMaker.createControl(item)
      );
    });

    this.formControls = this.formMaker.inputs;

    this.form.addControl(
      'description',
      new FormControl('')
    );
  }

  fillOtpValue(value: string) {
    this.otpCode = value
      .replace(/[^0-9]/g, '')
      .slice(0, 4);
  }

  async sendConsultationOTP() {
    if (this.otpSending) {
      return;
    }

    const formData: GiftInter = {
      ...formDataInit,
      firstName: this.form.controls['firstName']?.value || '',
      lastName: this.form.controls['lastName']?.value || '',
      phoneNumber: this.form.controls['phoneNumber']?.value || '',
      email: this.form.controls['Email']?.value || '',
      urlUserNeed:
        window.location.pathname +
        window.location.search,
      description:
        this.form.controls['description']?.value || ''
    };

    if (!await this.checkFormValidation(formData)) {
      this.toaster.error('خطا در فرم درخواست!!!');
      return;
    }

    try {
      this.otpSending = true;

      const res = await this.giftFormService.sendOTP(
        formData.phoneNumber,
        1,
        0,
        0
      );

      if (res?.success) {
        this.otpStep = true;
        this.otpCode = '';
      
        const isAlreadySent =
          res?.message === 'کد تایید قبلاً برای شما ارسال شده است.';
      
        const cooldownSeconds =
          isAlreadySent
            ? Number(res?.data) || 0
            : 60;
      
        this.startOtpCooldown(cooldownSeconds);
      
        this.giftFormService.toastSuccess(
          res?.message || 'کد تایید با موفقیت ارسال شد.'
        );
      }
      
      else {
        this.giftFormService.toastError(
          res?.message ||
          'ارسال کد تایید با خطا مواجه شد.'
        );
      }
      
    } catch (error) {
      this.giftFormService.toastError(
        'ارسال کد تایید با خطا مواجه شد.'
      );
    } finally {
      this.otpSending = false;
    }
  }

  async verifyConsultationOTP() {
    if (this.otpCode.length !== 4 || this.otpSending) {
      return;
    }

    try {
      this.otpSending = true;

      const phoneNumber =
        this.form.controls['phoneNumber']?.value || '';

      const res = await this.giftFormService.verifyOTP(
        phoneNumber,
        1,
        0,
        0,
        Number(this.otpCode)
      );

      if (!res?.success) {
        this.giftFormService.toastError(
          res?.message ||
          'کد تایید وارد شده صحیح نیست.'
        );
        return;
      }

      const formData: GiftInter = {
        ...formDataInit,
        firstName:
          this.form.controls['firstName']?.value || '',
        lastName:
          this.form.controls['lastName']?.value || '',
        phoneNumber,
        email:
          this.form.controls['Email']?.value || '',
        urlUserNeed:
          window.location.pathname +
          window.location.search,
        description:
          this.form.controls['description']?.value ||
          'پیامی وجود ندارد'
      };

      const createResult =
        await this.giftFormService.consultation_req(
          formData
        );

      if (createResult?.success) {
        this.giftFormService.toastSuccess(
          'درخواست مشاوره با موفقیت ثبت شد.'
        );

        this.form.reset();
        this.otpStep = false;
        this.otpCode = '';
      } else {
        this.giftFormService.toastError(
          createResult?.message ||
          'خطا در ثبت درخواست مشاوره.'
        );
      }
    } catch (error) {
      this.giftFormService.toastError(
        'خطا در تایید کد یا ثبت درخواست.'
      );
    } finally {
      this.otpSending = false;
    }
  }

  backToConsultationForm() {
    this.otpStep = false;
    this.otpCode = '';
    this.otpCooldown = 0;
  
    clearInterval(this.otpCooldownTimer);
    this.otpCooldownTimer = null;
  }

  async checkFormValidation(_formData: GiftInter) {
    const formErrors: { [key: string]: string[] } = {};

    for (const controlName in this.form.controls) {
      const control = this.form.controls[controlName];

      if (control.invalid) {
        formErrors[controlName] = [];

        if (control.errors?.['required']) {
          formErrors[controlName].push(
            `${controlName} is required.`
          );
        }

        if (control.errors?.['email']) {
          formErrors[controlName].push(
            `Invalid ${controlName} format.`
          );
        }

        if (control.errors?.['pattern']) {
          formErrors[controlName].push(
            `${controlName} must be a valid number.`
          );
        }
      }
    }

    return Object.keys(formErrors).length === 0;
  }

  scroll() {
    if (AppComponent.isBrowser.value) {
      const element =
        document.getElementById('form-consulting');

      element?.scrollIntoView({
        behavior: 'smooth'
      });
    } else {
      return;
    }
  }
}